import React from 'react'
import { SkeletonCell } from '../../components/SkeletonCell'
import styled from 'styled-components'
import { FormActions, FormContainer } from '../../components/FormBuilder/CustomForm/FormFiller'
import { useTheme } from '../../middleware/ThemeContext'

const EditRoleSkeleton = () => {
  const { theme } = useTheme();
  return (
    <SkeletonContainer>
        <SkeletonCell style={{ height: "24px", width: "100px", marginBottom: "20px" }} />
        <FormContainer theme={theme} className='p-3'>
            <SkeletonCell style={{ height: "15px", marginBottom: "20px" }} />
            {[...Array(2)].map((_, i) => (
                    <div key={i}>
                        <SkeletonCell style={{ height: "15px", width: "50px", marginBottom: "8px" }} />
                        <SkeletonCell style={{ height: "37px", marginBottom: "8px" }} />
                    </div>
            ))}
            <SkeletonCell style={{ height: "15px", width: "70%", marginTop: "8px" }} />
        </FormContainer>
        <FormActions>
            <SkeletonCell style={{ width: "97px", height: "42px" }} />
            <SkeletonCell style={{ width: "177px", height: "42px" }} />
        </FormActions>
    </SkeletonContainer>
  )
}

export default EditRoleSkeleton

const SkeletonContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  margin-top: 50px;
`;